import { useSelector } from "react-redux";
import { RootState } from "../../redux/store/store";
const useBoardAndItems = () => {
  const { currentBoard, itemIds } = useSelector((state: RootState) => state.monday);

  return {
    currentBoard,
    itemIds,
  };
};

export default useBoardAndItems;
